package com.shadowings.gero.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class SavedBuilderWord(
    val id: String = "",
    val mdc: String = "",
    val title: String = "",
    val meaning: String = "",
    val isRtl: Boolean = false,
    val isCartouche: Boolean = true,
    val timestamp: String = "0", // String, not Long — see UserData.consumablesUpdatedAt for why
    // Tombstone: a deletion is recorded here (with a bumped `timestamp`) instead of removing the
    // entry outright, so a sync merge can tell "deleted after cloud's copy" from "never existed"
    // and stop resurrecting words removed on one device. Filter these out at display time.
    val deleted: Boolean = false
)
